import { NgModule } from "@angular/core";
import { TfCopyToClipboardComponent } from "./components/tf-copy-to-clipboard/tf-copy-to-clipboard.component";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations:[TfCopyToClipboardComponent],
    exports: [TfCopyToClipboardComponent],
    providers: [],
    imports: [CommonModule,
        NgbPopoverModule]
})
export class TfCopyToClipboardModule {
}
